import { configureStore } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import authReducer from "./authSlice";
import agentsReducer from "./agentSlice";
import userSlice from "./userSlice";
import filtersReducer from "./filtersSlice";
import contractDashboardReducer from "./contractDashboardSlice";
import feedbackReducer from "./feedbackSlice";
import userRolesReducer from "./userRolesSlice";
import interviewHostReducer from "./interviewHostSlice";
import agentManagementReducer, { agentLookupReducer } from "./agentManagementSlice";
import procurementDashboardReducer from "./procurementDashboardSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    agents: agentsReducer,
    user: userSlice,
    filters: filtersReducer,
    contractDashboard: contractDashboardReducer,
    feedback: feedbackReducer,
    userRoles: userRolesReducer,
    interviewHost: interviewHostReducer,
    agentManagement: agentManagementReducer,
    agentLookup: agentLookupReducer,
    procurementDashboard: procurementDashboardReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore MSAL account objects which contain non-serializable Maps
        ignoredActions: ['auth/setUser'],
        ignoredPaths: ['auth.user'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export default store;
